import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";
import { UserIcon } from "lucide-react";
import { ExpenseFormValues } from "@/schemas/expenseFormSchema";

interface ParticipantSelectorProps {
  form: UseFormReturn<ExpenseFormValues>;
  tripParticipants: string[];
}

export const ParticipantSelector = ({ form, tripParticipants = [] }: ParticipantSelectorProps) => {
  return (
    <FormField
      control={form.control}
      name="paidBy"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Paid By</FormLabel>
          <Select onValueChange={field.onChange} defaultValue={field.value}>
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select who paid" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {tripParticipants.map((participant) => (
                <SelectItem key={participant} value={participant}>
                  <div className="flex items-center gap-2">
                    <UserIcon className="h-4 w-4" />
                    {participant}
                  </div>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};